import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { Entity } from '../../types/Entity';
import { CallBackEntityParams, Private_Routes } from '../../url';

export function useDecodedParams<P extends Record<string, string>>() {
  const params = useParams<P>();
  const decodedParams = {} as P;
  type ParamKeys = keyof P;
  Object.keys(params).forEach((key: ParamKeys) => {
    const value = decodeURIComponent(params[key] || '');
    decodedParams[key] = value as P[keyof P];
  });
  return decodedParams;
}
export const useTranspilerImportParams = () => {
  const [params] = useSearchParams();
  const callBackEntity = params.get('entity') as Entity;
  const callBackEntityId = params.get('entityId');
  const name = params.get('name') || '';
  const convertLookupsToJoin = params.get('convertLookupsToJoin') || '';
  const isJobTranspile = params.get('isJobTranspile') || '';
  const isLanguageEnabled = params.get('isLanguageEnabled') || '';
  const clusterSize = params.get('clusterSize') || '';
  const status = params.get('status') || '';
  const branch = params.get('branch') || '';
  const fabricId = params.get('fabricId') || '';
  const airflowFabricId = params.get('airflowFabricId') || '';
  const language = params.get('language') || '';
  const projectId = params.get('projectId') || '';
  const teamId = params.get('teamId') || '';
  const step = (params.get('step') || 1) as string;
  const source = params.get('source') || '';
  const searchParams: CallBackEntityParams = useMemo(
    () => ({
      step,
      source,
      teamId,
      language,
      branch,
      status,
      convertLookupsToJoin,
      name,
      projectId,
      fabricId,
      airflowFabricId,
      isJobTranspile,
      clusterSize,
      isLanguageEnabled
    }),
    [
      step,
      source,
      teamId,
      language,
      branch,
      status,
      convertLookupsToJoin,
      name,
      projectId,
      fabricId,
      airflowFabricId,
      isJobTranspile,
      clusterSize,
      isLanguageEnabled
    ]
  );
  return { teamId, callBackEntity, searchParams, callBackEntityId };
};
export const useTranspilerImportURL = () => {
  const { searchParams, teamId, callBackEntity, callBackEntityId } = useTranspilerImportParams();
  let url = Private_Routes.TranspilerImport.home.getUrl(undefined, searchParams);
  if (callBackEntityId) {
    url = Private_Routes.TranspilerImport.tab.getUrl({ transpileId: callBackEntityId }, searchParams);
  }

  const getCompleteUrl = (value: string, key: string) => {
    if (callBackEntityId && value) {
      if (key === 'projectId') {
        delete searchParams.branch;
      } else if (key === 'teamId') {
        delete searchParams.branch;
        delete searchParams.fabricId;
        delete searchParams.projectId;
        delete searchParams.airflowFabricId;
        delete searchParams.clusterSize;
      }
      return Private_Routes.TranspilerImport.tab.getUrl(
        { transpileId: callBackEntityId },
        {
          ...searchParams,
          [key]: value
        }
      );
    }
    return url;
  };
  return {
    transpilerImportURl: url,
    teamId,
    isTranspiler: callBackEntity === Entity.Transpiler,
    searchParams,
    getCompleteUrl
  };
};
